import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';

import {PreviewModalComponent} from "./index";

/**
 * Module for the Preview modal
 */
@NgModule({
  declarations: [PreviewModalComponent],
  entryComponents: [PreviewModalComponent],
  exports: [PreviewModalComponent],
  imports: [IonicModule],
  providers: [],
})
export class PreviewModalModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/preview-modal/preview-modal.module.ts